import messages from './messages.json';

export const PLACEHOLDER_WAITING_FOR_OFFERS =
  messages.placeholderTile.waitingForOffers;
export const PLACEHOLDER_AWAITING_OFFER_DETAILS =
  messages.placeholderTile.awaitingOfferDetails;
export const PLACEHOLDER_MINUTE_WARNING =
  messages.placeholderTile.minuteWarning;
export const PLACEHOLDER_LONGER_THAN_EXPECTED =
  messages.placeholderTile.longerThanExpected;
